// tslint:disable: completed-docs
import {
    SAILS_APP_NAME,
    CONTAINER_STORAGE,
} from 'Constant';

export const CREATE_INITIAL_STORAGE = `${SAILS_APP_NAME}/${CONTAINER_STORAGE}/CREATE_INITIAL_STORAGE`;
